/**
 * Extract message and error_code from a Tauri plugin error.
 *
 * Plugin commands that return `Result<T, PluginError>` where PluginError
 * implements custom Serialize will reject with `{ message, error_code }`.
 *
 * Used by all integration plugin bridges (Chronicle, GDT, Genie, EMIS).
 */
export function extractPluginError(error: unknown): {
  message: string;
  errorCode?: string;
  details?: unknown;
} {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    const obj = error as { message: string; error_code?: string; details?: unknown };
    return { message: obj.message, errorCode: obj.error_code, details: obj.details };
  }
  if (error instanceof Error) {
    return { message: error.message };
  }
  return { message: String(error) };
}
